export const EDIT_QUESTIONS_LINK = 'group-settings-edit-questions-link';
export const MEMBERSHIP_QUESTIONS = 'membership-questions';
export const MEMBERSHIP_QUESTION_ADD = 'membership-questions-add';
